import { render } from "./OrderNowComponent.vue?vue&type=template&id=57acf83f&scoped=true"
const script = {}

import "./OrderNowComponent.vue?vue&type=style&index=0&id=57acf83f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57acf83f"]])

export default __exports__